import React, {Component} from "react";
import {Button, Modal, Layout, Icon} from "antd";
import _ from "i18n";
import {connect} from "react-redux";
import { Row, Col } from 'antd';
import {getRecapByDay, displayRecapPaymentCsvFile, displayRecapPaymentPdfFile} from "../../../actions/thunks.js";
import {setFilterInvoicesByDay} from "../../../actions/actions.js";
import {formatAmount} from "utils";
import {map, reduce} from 'lodash';
import moment from "moment";

class RecapByMonth extends Component {


  componentDidMount() {
    if(this.props.statisticsFilter.apps && this.props.statisticsFilter.apps.length > 0) {
      this.props.getRecapByDay(this.props.statisticsFilter.apps && this.props.statisticsFilter.apps.length > 0 ? this.props.statisticsFilter.apps : [] , this.props.statisticsFilter.appRefs && this.props.statisticsFilter.appRefs.length > 0 ? this.props.statisticsFilter.appRefs : [], this.props.operationType ? this.props.operationType : null, this.props.statisticsFilter.appType && this.props.statisticsFilter.appType.length > 0 ? this.props.statisticsFilter.appType : [])
    }
  }


  componentDidUpdate(prevProps, prevState)
  {

    if((prevProps.operationType !== this.props.operationType) && this.props.operationType !== null) {

      this.props.getRecapByDay(this.props.statisticsFilter.apps && this.props.statisticsFilter.apps.length > 0 ? this.props.statisticsFilter.apps : [] , this.props.statisticsFilter.appRefs && this.props.statisticsFilter.appRefs.length > 0 ? this.props.statisticsFilter.appRefs : [], this.props.operationType ? this.props.operationType : null, this.props.statisticsFilter.appType && this.props.statisticsFilter.appType.length > 0 ? this.props.statisticsFilter.appType : [])
    }
  }


  constructBloc = ({amount, month}) => {

    return (
      <div>

        <div className="flex flex-row justify-between">
          <div className={this.props.recapByDay.filterDay == month ? "div-day-recap div-day-recap-active":"div-day-recap"} onClick={() => {
            this.setDayFilter(month)}}>
            {moment(month).format("MM/YYYY")}
          </div>
          <div className=" self-end pr-4  div-recap-amount">
            {formatAmount(amount)}
          </div>
        </div>
        <div className="line"/>
      </div>
    )

  }

  calculSum = () => {
    return reduce(this.props.recapByDay.items['month'], (sum, { amount }) => (sum + parseInt(amount)), 0);
  }


  toggleDayChecked = () => {

    this.props.setFilterInvoicesByDay(null)
  }

  setDayFilter = (month) => {

    this.props.setFilterInvoicesByDay(month)
  }

  getCsvFile = () => {
    this.props.changeState(true);
    this.props.displayRecapPaymentCsvFile(this.props.statisticsFilter.apps && this.props.statisticsFilter.apps.length > 0 ? this.props.statisticsFilter.apps : [] , this.props.statisticsFilter.appRefs && this.props.statisticsFilter.appRefs.length > 0 ? this.props.statisticsFilter.appRefs : [], this.props.operationType ? this.props.operationType : null).then((res) => {
      this.props.changeState(false);
    });
  }

  getPdfFile = () => {
    this.props.changeState(true);
    this.props.displayRecapPaymentPdfFile(this.props.statisticsFilter.apps && this.props.statisticsFilter.apps.length > 0 ? this.props.statisticsFilter.apps : [] , this.props.statisticsFilter.appRefs && this.props.statisticsFilter.appRefs.length > 0 ? this.props.statisticsFilter.appRefs : [], this.props.operationType ? this.props.operationType : null).then((res) => {
      this.props.changeState(false);
    });
  }

  render() {

    let {recapByDay} = this.props;

    if(!recapByDay || !recapByDay.items['month'] || recapByDay.items.length === 0) {

      return <div>

      </div>
    }

    return (
      <div  className="recap-day-container pl-4">

        <div className="flex flex-row justify-between align-center pt-8" >

        <div className="recap-day-title">
          {_('Date')}
        </div>

          <div className="flex">
          <div className="ml-2" onClick={this.getCsvFile}>
            <Icon type="file-excel" style={{ fontSize: '20px', color: '#2495e1' }} />
          </div>

          <div className="ml-2" onClick={this.getPdfFile}>
            <Icon type="file-pdf" style={{ fontSize: '20px', color: '#2495e1' }} />
          </div>

          </div>
        </div>
        <div className="pt-8 mb-2">

          <Button  type={recapByDay.filterDay === null ? 'primary' : 'default'} data-operation="ALL" onClick={() => this.toggleDayChecked()}>{_('ALL')} </Button>

        </div>

        <div className="pt-2 modal-recap-title">
          {_('MONTH')}
        </div>

        <div className="pt-4 scroll-div-recap-month w-48">
          { map(recapByDay.items['month'], this.constructBloc) }

        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  statisticsFilter: state.filters.statisticsFilter,
  recapByDay: state.recapByDay,
});

const mapDispatchToProps = {
  getRecapByDay,
  setFilterInvoicesByDay,
  displayRecapPaymentCsvFile,
  displayRecapPaymentPdfFile
};

export default connect(mapStateToProps, mapDispatchToProps)(RecapByMonth);



// WEBPACK FOOTER //
// ./app/components/Admin/statisctics/RecapByMonth.js